"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _universalCookie["default"];
exports["default"] = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/react-cookie@4.1.1_react@16.14.0/~/react-cookie/cjs/Cookies.js
// module id = 499
// module chunks = 0